<template>
  <div class="page-container-wrapper pb-5">
    <loader v-if="dataLoading"/>
    <template v-else>
      <div class="page-container-header d-flex align-items-center">
        <h2 class="text-md mb-0">{{ $t('message.User.users') }}</h2>

        <b-button class="mr-2" variant="primary" @click="$router.push('/users/add')">{{ $t('message.User.add') }}</b-button>
      </div>
      <div class="page-container" id="page-container">

        <div class="page-container-toolbar justify-content-between">
          <div class="col-sm-8">
            <b-row>
              <b-col sm="10">
                <b-form-input type="text" v-model="query" placeholder="search" @keyup.enter.native="getData"></b-form-input>
              </b-col>

              <b-col sm="1">
                <b-button class="btn btn-sm btn-white" @click="getData">
                  <i class="i-con i-con-search"><i></i></i>
                </b-button>
              </b-col>

              <b-col sm="1">
                <b-button v-if="query.length>0" class="btn btn-sm btn-danger" @click="clearQuery">
                  <i class="i-con i-con-close"><i></i></i>
                </b-button>
              </b-col>
            </b-row>
          </div>
        </div>

        <div class="padding">
          <template>
            <b-card>
              <b-table striped hover :items="users.data" :fields="fields">
                <template slot="last_name" slot-scope="data">
                  {{ data.item.name }}
                </template>

                <template slot="superuser" slot-scope="data">
                  <p v-html="data.item.superuser? $t('message.yes') : $t('message.no') "></p>
                </template>

                <template slot="roles" slot-scope="data">
                  <p> {{ $t('message.User.roles.' + data.item.role) }}</p>
                </template>

                <template slot="activated" slot-scope="data">
                  <p v-html="data.item.activated ? $t('message.yes') : $t('message.no')"></p>
                </template>

                <template slot="actions" slot-scope="data">
                  <div v-if="data.item.id != null" class="item-action dropdown">
                    <a href="#" data-toggle="dropdown" class="text-muted"><i class="i-con i-con-more"><i></i></i></a>
                    <div class="dropdown-menu dropdown-menu-right bg-dark" role="menu">
                      <router-link class="dropdown-item" :to="'/users/' + data.item.id + '/edit'">
                        {{ $t('message.edit') }}
                      </router-link>
                      <div class="dropdown-divider"></div>
                      <a class="dropdown-item" @click="deleteUserConfirm(data.item)">
                        {{ $t('message.delete') }}
                      </a>
                    </div>
                  </div>
                  <div v-else>
                    {{ $t('message.deleted') }}
                  </div>
                </template>
              </b-table>
            </b-card>
          </template>

          <template v-if="users.meta.last_page > 1">
            <b-pagination-nav size="md" :link-gen="linkGen" :use-router=true :total-rows="users.meta.total" :number-of-pages="users.meta.last_page"
                              v-model="users.meta.current_page" :per-page="10"></b-pagination-nav>
          </template>

        </div>
      </div>
      <b-button variant="primary" class="float-right mr-2" @click="$router.push('/users/add')">{{ $t('message.User.add') }}</b-button>
    </template>
  </div>
</template>

<script>
import {USERS_REQUEST, USERS_SET_QUERY} from '@/store/actions/users';
import {USER_DELETE} from '@/store/actions/user';
import {AUTH_LOGOUT} from '@/store/actions/auth';
import {mapState} from 'vuex'

export default {
  name: 'user-list',
  components: {},
  props: [],
  data() {
    return {
      users: {
        data: [],
        meta: {
          current_page: 1
        },
        links: {}
      },

      fields: {
        email: {
          label: this.$t('message.User.email'),
          sortable: true
        },
        last_name: {
          label: this.$t('message.User.name'),
          sortable: true
        },
        activated: {
          label: this.$t('message.User.activated'),
          sortable: true
        },
        superuser: {
          label: this.$t('message.User.superuser'),
          sortable: true,
        },
        roles: {
          label: this.$t('message.User.rolesLabel'),
        },
        actions: {
          sortable: false
        }
      }
    }
  },
  computed: {
    ...mapState({
      dataLoading: state => state.users.status === 'loading',
    }),
    query: {
      get: function () {
        return this.$store.state.users.users_query;
      },
      set: function (newValue) {
        this.$store.commit(USERS_SET_QUERY, newValue);
      }
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$store.dispatch(USERS_REQUEST, this.$route.params.page).then((response) => {
        this.users = response.data;
      }).catch((error) => {
        if (error.response.status == 401) {
          this.$store.dispatch(AUTH_LOGOUT);
          this.flash(this.$t("message.unauthenticated"), 'error', {timeout: 3000});
          if (this.$route.path !== '/') {
            this.$router.push('/');
          }
          ;
        }
      });
    },

    linkGen(pageNum) {
      return '/users/' + pageNum;
    },

    deleteUserConfirm(user) {
      this.$swal({
        title: this.$t("message.areYouSure"),
        html: this.$t("message.User.deleteWarning", {user: user.name}),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t("message.yesImSure"),
        cancelButtonText: this.$t("message.noCancel"),
      }).then((result) => {
        if (result.value) {
          this.deleteUser(user)
        }
      })
    },

    deleteUser(user) {
      this.$store.dispatch(USER_DELETE, user).then((response) => {
        user._rowVariant = "danger";
        user.id = null;
        this.$swal({
          title: this.$t("message.success"),
          html: this.$t("message.User.successfullyDeleted", {user: user.name}),
          type: 'success',
          showCancelButton: true,
        })
      }).catch((error) => {
        this.handleUnauth(error.response.status);
        this.handleForbidden(error.response.status);
      });
    },

    clearQuery() {
      this.$store.commit(USERS_SET_QUERY, '');
      this.getData();
    },
  },
  watch: {
    // whenever question changes, this function will run
    '$route.params.page': function (newPage) {
      this.$store.dispatch(USERS_REQUEST, newPage).then((response) => {
        this.users = response.data;
      });
    }
  },
}

</script>

<style scoped lang="scss">
.user-list {
}
</style>

